module.exports = __webpack_public_path__ + "wordScaleSnapInLeft.gif";